export const lightenColor = (color: string, percent: number): string => {
    const originalColorValue = parseInt(color.replace("#", ""), 16);
    const brightnessAdjustment = Math.round(2.55 * percent);

    const clamp = (value: number): number => Math.min(255, Math.max(0, value));

    const adjustComponent = (component: number): number =>
        clamp(component + brightnessAdjustment);

    const adjustedR = adjustComponent((originalColorValue >> 16) & 0xff);
    const adjustedG = adjustComponent((originalColorValue >> 8) & 0xff);
    const adjustedB = adjustComponent(originalColorValue & 0xff);

    return `#${((adjustedR << 16) | (adjustedG << 8) | adjustedB)
        .toString(16)
        .padStart(6, "0")}`;
};
